/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAnimalsByOrganizationQueryResponse, ListAnimalsByOrganizationPathParams, ListAnimalsByOrganizationQueryParams, ListAnimalsByOrganization400, ListAnimalsByOrganization401, ListAnimalsByOrganization403, ListAnimalsByOrganization404, ListAnimalsByOrganization409, ListAnimalsByOrganization500 } from "../../types/livestockController/ListAnimalsByOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAnimalsByOrganizationUrl(organizationId: ListAnimalsByOrganizationPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/animals` as const }
  return res
}

/**
 * @summary List animals across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/animals}
 */
export async function listAnimalsByOrganization(organizationId: ListAnimalsByOrganizationPathParams["organizationId"], params?: ListAnimalsByOrganizationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAnimalsByOrganizationQueryResponse, ResponseErrorConfig<ListAnimalsByOrganization400 | ListAnimalsByOrganization401 | ListAnimalsByOrganization403 | ListAnimalsByOrganization404 | ListAnimalsByOrganization409 | ListAnimalsByOrganization500>, unknown>({ method : "GET", url : getListAnimalsByOrganizationUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}